import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faImages, faTags, faPlus, faSync } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './GaleriaData.css';

export default function GaleriaData() {
    // Pestaña activa ('fotos' o 'categorias')
    const [activeTab, setActiveTab] = useState('fotos');

    // ==========================================
    // ESTADOS: FOTOS DE GALERÍA
    // ==========================================
    const [fotos, setFotos] = useState([]);
    const [loadingFotos, setLoadingFotos] = useState(true);
    const [filtroTitulo, setFiltroTitulo] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [imagenZoom, setImagenZoom] = useState(null);

    // Modal Crear Foto
    const [modalCrearFoto, setModalCrearFoto] = useState(false);
    const [tituloFoto, setTituloFoto] = useState('');
    const [categoriaFoto, setCategoriaFoto] = useState('');
    const [descripcionFoto, setDescripcionFoto] = useState('');
    const [archivoImagen, setArchivoImagen] = useState(null);
    const [previewCrear, setPreviewCrear] = useState(null);
    const [guardandoFoto, setGuardandoFoto] = useState(false);

    // Modal Editar Foto
    const [modalEditarFoto, setModalEditarFoto] = useState(false);
    const [fotoAEditar, setFotoAEditar] = useState(null);
    const [editTitulo, setEditTitulo] = useState('');
    const [editCategoria, setEditCategoria] = useState('');
    const [editDescripcion, setEditDescripcion] = useState('');
    const [editArchivoImagen, setEditArchivoImagen] = useState(null);
    const [previewEditar, setPreviewEditar] = useState(null);
    const [actualizandoFoto, setActualizandoFoto] = useState(false);

    // ==========================================
    // ESTADOS: CATEGORÍAS DE GALERÍA
    // ==========================================
    const [categorias, setCategorias] = useState([]);
    const [loadingCategorias, setLoadingCategorias] = useState(true);
    const [filtroCatTexto, setFiltroCatTexto] = useState('');

    // Modal Crear Categoría
    const [modalCrearCategoria, setModalCrearCategoria] = useState(false);
    const [nombreNuevaCategoria, setNombreNuevaCategoria] = useState('');
    const [guardandoCategoria, setGuardandoCategoria] = useState(false);

    // Modal Editar Categoría
    const [modalEditarCategoria, setModalEditarCategoria] = useState(false);
    const [categoriaAEditar, setCategoriaAEditar] = useState(null);
    const [nombreEditCategoria, setNombreEditCategoria] = useState('');
    const [actualizandoCategoria, setActualizandoCategoria] = useState(false);

    useEffect(() => {
        cargarFotos();
        cargarCategorias();
    }, []);

    // ==========================================
    // CARGA DE DATOS
    // ==========================================
    const cargarFotos = () => {
        setLoadingFotos(true);
        fetch(`${baseURL}/galeriaGet.php`, { method: 'GET' })
            .then(res => res.json())
            .then(data => {
                setFotos(data.fotos || []);
                setLoadingFotos(false);
            })
            .catch(err => {
                console.error('Error al cargar fotos de galería:', err);
                setLoadingFotos(false);
            });
    };

    const cargarCategorias = () => {
        setLoadingCategorias(true);
        fetch(`${baseURL}/categoriasGaleriaGet.php`, { method: 'GET' })
            .then(res => res.json())
            .then(data => {
                setCategorias(data.categorias || []);
                setLoadingCategorias(false);
            })
            .catch(err => {
                console.error('Error al cargar categorías de galería:', err);
                setLoadingCategorias(false);
            });
    };

    // ==========================================
    // CRUD: FOTOS
    // ==========================================
    const handleCrearFoto = async (e) => {
        e.preventDefault();
        if (!archivoImagen) {
            toast.error('Debe seleccionar una foto');
            return;
        }

        setGuardandoFoto(true);
        try {
            const formData = new FormData();
            formData.append('titulo', tituloFoto);
            formData.append('categoria', categoriaFoto);
            formData.append('descripcion', descripcionFoto);
            formData.append('imagen', archivoImagen);

            const res = await fetch(`${baseURL}/galeriaPost.php`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });
            const data = await res.json();

            if (res.ok && data.mensaje) {
                toast.success(data.mensaje);
                setModalCrearFoto(false);
                setTituloFoto('');
                setCategoriaFoto('');
                setDescripcionFoto('');
                setArchivoImagen(null);
                setPreviewCrear(null);
                cargarFotos();
            } else {
                toast.error(data.error || 'Error al guardar la foto');
            }
        } catch (err) {
            console.error(err);
            toast.error('Error al guardar la foto');
        } finally {
            setGuardandoFoto(false);
        }
    };

    const abrirModalEditarFoto = (foto) => {
        setFotoAEditar(foto);
        setEditTitulo(foto.titulo || '');
        setEditCategoria(foto.categoria || '');
        setEditDescripcion(foto.descripcion || '');
        setEditArchivoImagen(null);
        setPreviewEditar(foto.imagen || null);
        setModalEditarFoto(true);
    };

    const handleActualizarFoto = async (e) => {
        e.preventDefault();
        if (!fotoAEditar) return;

        setActualizandoFoto(true);
        try {
            const formData = new FormData();
            formData.append('idFoto', fotoAEditar.idFoto);
            formData.append('titulo', editTitulo);
            formData.append('categoria', editCategoria);
            formData.append('descripcion', editDescripcion);
            if (editArchivoImagen) {
                formData.append('imagen', editArchivoImagen);
            }

            const res = await fetch(`${baseURL}/galeriaPut.php?idFoto=${fotoAEditar.idFoto}`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });
            const data = await res.json();

            if (res.ok && data.mensaje) {
                toast.success(data.mensaje);
                setModalEditarFoto(false);
                setFotoAEditar(null);
                cargarFotos();
            } else {
                toast.error(data.error || 'Error al actualizar');
            }
        } catch (err) {
            console.error(err);
            toast.error('Error al actualizar la foto');
        } finally {
            setActualizandoFoto(false);
        }
    };

    const eliminarFoto = (idFoto, titulo) => {
        Swal.fire({
            title: '¿Eliminar foto?',
            text: `Se eliminará permanentemente "${titulo}".`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await fetch(`${baseURL}/galeriaDelete.php?idFoto=${idFoto}`, {
                        method: 'DELETE',
                        credentials: 'include',
                    });
                    const data = await res.json();
                    if (res.ok && data.mensaje) {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarFotos();
                    } else {
                        toast.error(data.error || 'Error al eliminar');
                    }
                } catch (err) {
                    console.error(err);
                    toast.error('Error al eliminar');
                }
            }
        });
    };

    // ==========================================
    // CRUD: CATEGORÍAS
    // ==========================================
    const handleCrearCategoria = async (e) => {
        e.preventDefault();
        if (!nombreNuevaCategoria.trim()) return;

        setGuardandoCategoria(true);
        try {
            const res = await fetch(`${baseURL}/categoriasGaleriaPost.php`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ categoria: nombreNuevaCategoria.trim() }),
            });
            const data = await res.json();

            if (res.ok && data.mensaje) {
                toast.success(data.mensaje);
                setModalCrearCategoria(false);
                setNombreNuevaCategoria('');
                cargarCategorias();
            } else {
                toast.error(data.error || 'Error al crear categoría');
            }
        } catch (err) {
            console.error(err);
            toast.error('Error al crear categoría');
        } finally {
            setGuardandoCategoria(false);
        }
    };

    const abrirModalEditarCategoria = (cat) => {
        setCategoriaAEditar(cat);
        setNombreEditCategoria(cat.categoria || '');
        setModalEditarCategoria(true);
    };

    const handleActualizarCategoria = async (e) => {
        e.preventDefault();
        if (!categoriaAEditar || !nombreEditCategoria.trim()) return;

        setActualizandoCategoria(true);
        try {
            const res = await fetch(`${baseURL}/categoriasGaleriaPut.php?idCategoria=${categoriaAEditar.idCategoria}`, {
                method: 'PUT',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ categoria: nombreEditCategoria.trim() }),
            });
            const data = await res.json();

            if (res.ok && data.mensaje) {
                toast.success(data.mensaje);
                setModalEditarCategoria(false);
                setCategoriaAEditar(null);
                cargarCategorias();
            } else {
                toast.error(data.error || 'Error al actualizar');
            }
        } catch (err) {
            console.error(err);
            toast.error('Error al actualizar categoría');
        } finally {
            setActualizandoCategoria(false);
        }
    };

    const eliminarCategoria = (idCategoria, nombreCat) => {
        Swal.fire({
            title: '¿Eliminar categoría?',
            text: `Se eliminará "${nombreCat}". Las fotos asociadas mantendrán su etiqueta.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await fetch(`${baseURL}/categoriasGaleriaDelete.php?idCategoria=${idCategoria}`, {
                        method: 'DELETE',
                        credentials: 'include',
                    });
                    const data = await res.json();
                    if (res.ok && data.mensaje) {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarCategorias();
                    } else {
                        toast.error(data.error || 'Error al eliminar');
                    }
                } catch (err) {
                    console.error(err);
                    toast.error('Error al eliminar categoría');
                }
            }
        });
    };

    // ==========================================
    // FILTROS
    // ==========================================
    const fotosFiltradas = fotos.filter(f => {
        const matchTitulo = !filtroTitulo || (f.titulo && f.titulo.toLowerCase().includes(filtroTitulo.toLowerCase())) ||
            (f.descripcion && f.descripcion.toLowerCase().includes(filtroTitulo.toLowerCase()));
        const matchCat = !filtroCategoria || f.categoria === filtroCategoria;
        return matchTitulo && matchCat;
    });

    const categoriasFiltradas = categorias.filter(c => {
        return !filtroCatTexto || (c.categoria && c.categoria.toLowerCase().includes(filtroCatTexto.toLowerCase()));
    });

    return (
        <div>
            <ToastContainer />

            {/* PESTAÑAS PRINCIPALES */}
            <div className="galeriaTabs">
                <button
                    className={`galeriaTabBtn ${activeTab === 'fotos' ? 'activeTab' : ''}`}
                    onClick={() => setActiveTab('fotos')}
                >
                    <FontAwesomeIcon icon={faImages} /> Fotos de Galería ({fotos.length})
                </button>
                <button
                    className={`galeriaTabBtn ${activeTab === 'categorias' ? 'activeTab' : ''}`}
                    onClick={() => setActiveTab('categorias')}
                >
                    <FontAwesomeIcon icon={faTags} /> Categorías ({categorias.length})
                </button>
            </div>

            {/* ==================================================== */}
            {/* PESTAÑA 1: FOTOS                                     */}
            {/* ==================================================== */}
            {activeTab === 'fotos' && (
                <>
                    <div className="galeriaHeaderActions">
                        <div className="galeriaFiltros">
                            <input
                                type="text"
                                placeholder="Buscar por título o descripción..."
                                value={filtroTitulo}
                                onChange={(e) => setFiltroTitulo(e.target.value)}
                            />
                            <select
                                value={filtroCategoria}
                                onChange={(e) => setFiltroCategoria(e.target.value)}
                            >
                                <option value="">Todas las categorías</option>
                                {categorias.map(cat => (
                                    <option key={cat.idCategoria} value={cat.categoria}>
                                        {cat.categoria}
                                    </option>
                                ))}
                            </select>
                            <button
                                className="tabBtn"
                                style={{ padding: '8px 12px', border: '1px solid #cbd5e1' }}
                                onClick={cargarFotos}
                                title="Recargar fotos"
                            >
                                <FontAwesomeIcon icon={faSync} />
                            </button>
                        </div>

                        <button
                            className="btnPost"
                            onClick={() => {
                                setTituloFoto('');
                                setCategoriaFoto(categorias[0]?.categoria || '');
                                setDescripcionFoto('');
                                setArchivoImagen(null);
                                setPreviewCrear(null);
                                setModalCrearFoto(true);
                            }}
                        >
                            <FontAwesomeIcon icon={faPlus} /> Nueva Foto
                        </button>
                    </div>

                    <div className="table-container">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Foto</th>
                                    <th>Título</th>
                                    <th>Categoría</th>
                                    <th>Descripción</th>
                                    <th>Fecha</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loadingFotos ? (
                                    <tr>
                                        <td colSpan="7" className="emptyState">Cargando fotos de la galería...</td>
                                    </tr>
                                ) : fotosFiltradas.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" className="emptyState">No se encontraron fotos en la galería.</td>
                                    </tr>
                                ) : (
                                    fotosFiltradas.map(item => (
                                        <tr key={item.idFoto}>
                                            <td>{item.idFoto}</td>
                                            <td>
                                                {item.imagen ? (
                                                    <img
                                                        src={item.imagen}
                                                        alt={item.titulo}
                                                        className="imgMiniaturaGaleria"
                                                        onClick={() => setImagenZoom(item.imagen)}
                                                        title="Clic para ampliar"
                                                    />
                                                ) : (
                                                    <span style={{ color: '#94a3b8', fontSize: '0.85rem' }}>Sin foto</span>
                                                )}
                                            </td>
                                            <td style={{ fontWeight: 600 }}>{item.titulo}</td>
                                            <td>
                                                <span className="badgeCategoriaGaleria">
                                                    {item.categoria || 'General'}
                                                </span>
                                            </td>
                                            <td style={{ maxWidth: '280px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {item.descripcion || '-'}
                                            </td>
                                            <td style={{ fontSize: '0.85rem', color: '#64748b' }}>
                                                {item.createdAt ? new Date(item.createdAt).toLocaleDateString() : '-'}
                                            </td>
                                            <td>
                                                <button
                                                    className="editar"
                                                    onClick={() => abrirModalEditarFoto(item)}
                                                    title="Editar Foto"
                                                >
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </button>
                                                <button
                                                    className="eliminar"
                                                    onClick={() => eliminarFoto(item.idFoto, item.titulo)}
                                                    title="Eliminar Foto"
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            )}

            {/* ==================================================== */}
            {/* PESTAÑA 2: CATEGORÍAS DE GALERÍA                     */}
            {/* ==================================================== */}
            {activeTab === 'categorias' && (
                <>
                    <div className="galeriaHeaderActions">
                        <div className="galeriaFiltros">
                            <input
                                type="text"
                                placeholder="Buscar categoría..."
                                value={filtroCatTexto}
                                onChange={(e) => setFiltroCatTexto(e.target.value)}
                            />
                            <button
                                className="tabBtn"
                                style={{ padding: '8px 12px', border: '1px solid #cbd5e1' }}
                                onClick={cargarCategorias}
                                title="Recargar categorías"
                            >
                                <FontAwesomeIcon icon={faSync} />
                            </button>
                        </div>

                        <button
                            className="btnPost"
                            onClick={() => {
                                setNombreNuevaCategoria('');
                                setModalCrearCategoria(true);
                            }}
                        >
                            <FontAwesomeIcon icon={faPlus} /> Nueva Categoría
                        </button>
                    </div>

                    <div className="table-container">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Categoría</th>
                                    <th>Fecha de Registro</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loadingCategorias ? (
                                    <tr>
                                        <td colSpan="4" className="emptyState">Cargando categorías...</td>
                                    </tr>
                                ) : categoriasFiltradas.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="emptyState">No hay categorías registradas.</td>
                                    </tr>
                                ) : (
                                    categoriasFiltradas.map(cat => (
                                        <tr key={cat.idCategoria}>
                                            <td>{cat.idCategoria}</td>
                                            <td style={{ fontWeight: 600 }}>{cat.categoria}</td>
                                            <td style={{ fontSize: '0.85rem', color: '#64748b' }}>
                                                {cat.createdAt ? new Date(cat.createdAt).toLocaleDateString() : '-'}
                                            </td>
                                            <td>
                                                <button
                                                    className="editar"
                                                    onClick={() => abrirModalEditarCategoria(cat)}
                                                    title="Editar Categoría"
                                                >
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </button>
                                                <button
                                                    className="eliminar"
                                                    onClick={() => eliminarCategoria(cat.idCategoria, cat.categoria)}
                                                    title="Eliminar Categoría"
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            )}

            {/* ==================================================== */}
            {/* MODAL CREAR FOTO                                     */}
            {/* ==================================================== */}
            {modalCrearFoto && (
                <div className="modal">
                    <div className="modal-content">
                        <div className="deFlexBtnsModal">
                            <h3 style={{ margin: 0, color: 'var(--color1, #3F1D76)' }}>
                                <FontAwesomeIcon icon={faImages} /> Agregar Foto a la Galería
                            </h3>
                            <span className="close" onClick={() => setModalCrearFoto(false)}>
                                &times;
                            </span>
                        </div>

                        <form onSubmit={handleCrearFoto} style={{ marginTop: '15px' }}>
                            <div className="flexGrap">
                                <fieldset style={{ flex: '1 1 100%' }}>
                                    <legend>Título de la foto *</legend>
                                    <input
                                        type="text"
                                        required
                                        placeholder="Ej. Cueva de las Pavas al atardecer"
                                        value={tituloFoto}
                                        onChange={(e) => setTituloFoto(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset style={{ flex: '1 1 100%' }}>
                                    <legend>Categoría</legend>
                                    <select
                                        value={categoriaFoto}
                                        onChange={(e) => setCategoriaFoto(e.target.value)}
                                        style={{ width: '100%', padding: '10px', border: 'none', background: 'transparent' }}
                                    >
                                        <option value="">Seleccionar o escribir...</option>
                                        {categorias.map(cat => (
                                            <option key={cat.idCategoria} value={cat.categoria}>
                                                {cat.categoria}
                                            </option>
                                        ))}
                                    </select>
                                    <input
                                        type="text"
                                        placeholder="O ingrese una nueva categoría..."
                                        style={{ marginTop: '6px' }}
                                        value={categoriaFoto}
                                        onChange={(e) => setCategoriaFoto(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset style={{ flex: '1 1 100%' }}>
                                    <legend>Descripción (opcional)</legend>
                                    <textarea
                                        rows="3"
                                        placeholder="Breve reseña o información del lugar..."
                                        value={descripcionFoto}
                                        onChange={(e) => setDescripcionFoto(e.target.value)}
                                        style={{ width: '100%', padding: '10px', border: 'none', background: 'transparent', resize: 'vertical' }}
                                    />
                                </fieldset>

                                <fieldset style={{ flex: '1 1 100%' }}>
                                    <legend>Seleccionar Imagen *</legend>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        required
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                setArchivoImagen(file);
                                                setPreviewCrear(URL.createObjectURL(file));
                                            }
                                        }}
                                    />
                                    {previewCrear && (
                                        <img src={previewCrear} alt="Vista previa" className="previewImgUpload" />
                                    )}
                                </fieldset>
                            </div>

                            <button
                                type="submit"
                                className="btnPost"
                                disabled={guardandoFoto}
                                style={{ marginTop: '20px', width: '100%' }}
                            >
                                {guardandoFoto ? 'Guardando foto...' : 'Publicar Foto'}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {/* ==================================================== */}
            {/* MODAL EDITAR FOTO                                    */}
            {/* ==================================================== */}
            {modalEditarFoto && fotoAEditar && (
                <div className="modal">
                    <div className="modal-content">
                        <div className="deFlexBtnsModal">
                            <h3 style={{ margin: 0, color: 'var(--color1, #3F1D76)' }}>
                                <FontAwesomeIcon icon={faEdit} /> Editar Foto
                            </h3>
                            <span className="close" onClick={() => setModalEditarFoto(false)}>
                                &times;
                            </span>
                        </div>

                        <form onSubmit={handleActualizarFoto} style={{ marginTop: '15px' }}>
                            <div className="flexGrap">
                                <fieldset style={{ flex: '1 1 100%' }}>
                                    <legend>Título de la foto *</legend>
                                    <input
                                        type="text"
                                        required
                                        value={editTitulo}
                                        onChange={(e) => setEditTitulo(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset style={{ flex: '1 1 100%' }}>
                                    <legend>Categoría</legend>
                                    <select
                                        value={editCategoria}
                                        onChange={(e) => setEditCategoria(e.target.value)}
                                        style={{ width: '100%', padding: '10px', border: 'none', background: 'transparent' }}
                                    >
                                        <option value="">Seleccionar o escribir...</option>
                                        {categorias.map(cat => (
                                            <option key={cat.idCategoria} value={cat.categoria}>
                                                {cat.categoria}
                                            </option>
                                        ))}
                                    </select>
                                    <input
                                        type="text"
                                        placeholder="O ingrese una nueva categoría..."
                                        style={{ marginTop: '6px' }}
                                        value={editCategoria}
                                        onChange={(e) => setEditCategoria(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset style={{ flex: '1 1 100%' }}>
                                    <legend>Descripción</legend>
                                    <textarea
                                        rows="3"
                                        value={editDescripcion}
                                        onChange={(e) => setEditDescripcion(e.target.value)}
                                        style={{ width: '100%', padding: '10px', border: 'none', background: 'transparent', resize: 'vertical' }}
                                    />
                                </fieldset>

                                <fieldset style={{ flex: '1 1 100%' }}>
                                    <legend>Cambiar Imagen (opcional)</legend>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                setEditArchivoImagen(file);
                                                setPreviewEditar(URL.createObjectURL(file));
                                            }
                                        }}
                                    />
                                    {previewEditar && (
                                        <img src={previewEditar} alt="Vista previa" className="previewImgUpload" />
                                    )}
                                </fieldset>
                            </div>

                            <button
                                type="submit"
                                className="btnPost"
                                disabled={actualizandoFoto}
                                style={{ marginTop: '20px', width: '100%' }}
                            >
                                {actualizandoFoto ? 'Actualizando...' : 'Guardar Cambios'}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {/* ==================================================== */}
            {/* MODAL CREAR CATEGORÍA                                */}
            {/* ==================================================== */}
            {modalCrearCategoria && (
                <div className="modal">
                    <div className="modal-content">
                        <div className="deFlexBtnsModal">
                            <h3 style={{ margin: 0, color: 'var(--color1, #3F1D76)' }}>
                                <FontAwesomeIcon icon={faTags} /> Nueva Categoría de Galería
                            </h3>
                            <span className="close" onClick={() => setModalCrearCategoria(false)}>
                                &times;
                            </span>
                        </div>

                        <form onSubmit={handleCrearCategoria} style={{ marginTop: '15px' }}>
                            <div className="flexGrap">
                                <fieldset style={{ flex: '1 1 100%' }}>
                                    <legend>Nombre de la Categoría *</legend>
                                    <input
                                        type="text"
                                        required
                                        placeholder="Ej. Cascadas, Aventura, Gastronomía, Rutas"
                                        value={nombreNuevaCategoria}
                                        onChange={(e) => setNombreNuevaCategoria(e.target.value)}
                                    />
                                </fieldset>
                            </div>

                            <button
                                type="submit"
                                className="btnPost"
                                disabled={guardandoCategoria}
                                style={{ marginTop: '20px', width: '100%' }}
                            >
                                {guardandoCategoria ? 'Guardando...' : 'Crear Categoría'}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {/* ==================================================== */}
            {/* MODAL EDITAR CATEGORÍA                               */}
            {/* ==================================================== */}
            {modalEditarCategoria && categoriaAEditar && (
                <div className="modal">
                    <div className="modal-content">
                        <div className="deFlexBtnsModal">
                            <h3 style={{ margin: 0, color: 'var(--color1, #3F1D76)' }}>
                                <FontAwesomeIcon icon={faEdit} /> Editar Categoría de Galería
                            </h3>
                            <span className="close" onClick={() => setModalEditarCategoria(false)}>
                                &times;
                            </span>
                        </div>

                        <form onSubmit={handleActualizarCategoria} style={{ marginTop: '15px' }}>
                            <div className="flexGrap">
                                <fieldset style={{ flex: '1 1 100%' }}>
                                    <legend>Nombre de la Categoría *</legend>
                                    <input
                                        type="text"
                                        required
                                        value={nombreEditCategoria}
                                        onChange={(e) => setNombreEditCategoria(e.target.value)}
                                    />
                                </fieldset>
                            </div>

                            <button
                                type="submit"
                                className="btnPost"
                                disabled={actualizandoCategoria}
                                style={{ marginTop: '20px', width: '100%' }}
                            >
                                {actualizandoCategoria ? 'Actualizando...' : 'Guardar Cambios'}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {/* ==================================================== */}
            {/* MODAL ZOOM DE IMAGEN                                 */}
            {/* ==================================================== */}
            {imagenZoom && (
                <div className="modalGaleriaZoom" onClick={() => setImagenZoom(null)}>
                    <img src={imagenZoom} alt="Ampliación" className="modalGaleriaZoomImg" />
                </div>
            )}
        </div>
    );
}
